import { render, staticRenderFns } from "./PrivateMessages.vue?vue&type=template&id=409c6335&scoped=true"
import script from "./PrivateMessages.vue?vue&type=script&lang=js"
export * from "./PrivateMessages.vue?vue&type=script&lang=js"
import style0 from "./PrivateMessages.vue?vue&type=style&index=0&id=409c6335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409c6335",
  null
  
)

export default component.exports